import React from 'react';
import { gql, useQuery } from '@apollo/client';
import SideBar from '../../components/SideBar';

const MY_HISTORY = gql`
  query MyHistory {
    myHistory {
      muxPlaybackId
      coordinates
    }
  }
`;

const History = () => {
  const { data, loading, error } = useQuery(MY_HISTORY);

  if (loading) return <p className="p-8 text-white">Loading history…</p>;
  if (error)   return <p className="p-8 text-red-500">Error: {error.message}</p>;

  return (
    <div className="relative flex w-full h-screen bg-[#242424]">
      <div className="z-10">
        <SideBar />
      </div>

      <div className="flex-1 p-8 overflow-y-auto">
        <h1 className="text-3xl font-semibold text-white mb-4">History</h1>
        <div className="grid grid-cols-4 gap-6 mt-8">
          {data.myHistory.map(({ muxPlaybackId }, idx) => (
            <div key={idx}>
              {/* Thumbnail Card */}
              <div className="h-60 rounded-lg overflow-hidden bg-gray-800">
                <img
                  src={`https://image.mux.com/${muxPlaybackId}/thumbnail.jpg?time=0&width=400`}
                  alt="Video thumbnail"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default History;
